const KeyboardAwareScrollView = require('react-native-keyboard-aware-scroll-view')
  .KeyboardAwareScrollView;

exports._keyboardAwareScrollView = KeyboardAwareScrollView;
